import { render } from "./jump.vue?vue&type=template&id=b965cddc"
import script from "./jump.vue?vue&type=script&lang=js"
export * from "./jump.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__